module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Patient-Zero.ba6f5a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Patient-Zero.jpg
// module id = wAds
// module chunks = 0